import React from 'react'
import { useDispatch } from 'react-redux'

import { trackNoteClicked } from 'data/analytics/actions'
import { Wrapper, ChannelItem, NoteItem } from './Layout'

export default function NotesBreadcrumb({
  isLoading,
  isPrivate,
  hasError,
  note,
  channel,
  parentNotes,
}) {
  const dispatch = useDispatch()
  const onNoteClick = React.useCallback(
    () => {
      dispatch(trackNoteClicked({ source: 'breadcrumb' }))
    },
    [dispatch]
  )

  if (hasError || isLoading) {
    return <Wrapper />
  }

  return (
    <Wrapper>
      <ChannelItem isPrivate={isPrivate} channel={channel} />
      {parentNotes.map(note => (
        <NoteItem key={note.id} note={note} onClick={onNoteClick} />
      ))}
      <NoteItem note={note} onClick={onNoteClick} />
    </Wrapper>
  )
}
